import * as React from 'react';
import { Controller } from 'react-hook-form';
// Import the inferred type
import { TeamTypesEnum } from 'types/generated/client';
import toTitleCase from 'utils/shared/string/toTitleCase';
import InputField from 'components/tournaments/InputField';
import { InputType } from 'components/tournaments/InputField/InputField';
import classNames from 'styles/utils/classNames';
import { EventTypeTabProps } from '../types';

const event = {
  groups: [
    {
      teamType: TeamTypesEnum.Doubles,
    },
    {
      teamType: TeamTypesEnum.Singles,
    },
  ],
};

const EventTypeTabs = ({
  control,
  errors,
  field,
  index,
  onChange,
  register,
  maxEvents,
}: EventTypeTabProps) => {
  console.log('errors', errors);
  return (
    <div className="h-auto min-h-10">
      <div className="tabs mb-4 mt-2 flex space-x-4">
        {event.groups.map((group, idx) => (
          <button
            key={idx}
            type="button"
            className={classNames(
              'typography-product-element-label w-full rounded-md px-4 py-2',
              field.activeTab === idx ? 'bg-black text-white' : 'bg-gray-200 text-gray-800',
            )}
            onClick={() => onChange(index, idx, field)} // Pass the correct tab index
          >
            {toTitleCase(group.teamType)}
          </button>
        ))}
      </div>
      <div className={classNames('h-auto pb-4', index > 0 || index < maxEvents ? 'border-b' : '')}>
        {field.activeTab === 0 && (
          <>
            <Controller
              name={`events.${index}.doubles`}
              control={control}
              render={({ field }) => (
                <InputField
                  fieldLabel="Title"
                  errors={errors}
                  placeholder="Doubles"
                  name={`events[${index}].doubles`}
                  register={register}
                  inputType={InputType.LabelInput}
                />
              )}
            />

            {errors?.events?.[index]?.doubles && (
              <p className="bottom-1 max-w-sm pl-1 text-[0.75rem] text-color-text-brand dark:text-color-text-brand">
                {errors?.events?.[index]?.doubles?.message || ''}
              </p>
            )}
          </>
        )}
        {field.activeTab === 1 && (
          <>
            <Controller
              name={`events.${index}.singles`}
              control={control}
              render={({ field }) => (
                <InputField
                  fieldLabel="Title"
                  errors={errors}
                  placeholder="Singles"
                  name={`events[${index}].singles`}
                  register={register}
                  inputType={InputType.LabelInput}
                />
              )}
            />
            {errors?.events?.[index]?.doubles && (
              <p className="bottom-1 max-w-sm pl-1 text-[0.75rem] text-color-text-brand dark:text-color-text-brand">
                {errors?.events?.[index]?.doubles?.message || ''}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EventTypeTabs;
